const path = "/administrativo/admin-config";

const endpoint = { version: `${path}/version` };

export default endpoint;
